import { GA4Logger } from '@zep/analytics';
import {
  HyperdxLogger,
  registerLogger,
  SentryLogger,
  ZettaLogger,
} from '@zep/core-logger';
import { ZEPLogger } from '@zep/logger';
import {
  getApplicationSessionId,
  getBrowserSessionId,
  getCorrelationId,
  getDeviceId,
} from '@zep/session-id';

import {
  ga4Dispatch,
  hyperdxLoggerConfig,
  Sentry,
  zettaClient,
} from './config';

const zettaLogger = new ZettaLogger(zettaClient);

const ga4Logger = new GA4Logger({
  dispatch: ga4Dispatch,
});

const hyperdxLogger = new HyperdxLogger(hyperdxLoggerConfig);

const sentryLogger = new SentryLogger(Sentry);

const appLogger = new ZEPLogger({
  loggers: [zettaLogger, ga4Logger, hyperdxLogger, sentryLogger],
  initialState: {
    zep_service_name: 'zep-core',
    zep_deployment_env: process.env.NEXT_PUBLIC_STAGE,
    zepBrowserSessionId: getBrowserSessionId(),
    zepApplicationSessionId: getApplicationSessionId(),
    zep_device_id: getDeviceId(),
    zep_correlation_id: getCorrelationId(),
    deploymentCommitId: process.env.NEXT_PUBLIC_COMMIT_SHA,
  },
});
registerLogger(appLogger);
